import { formatCallerNumber, translate } from 'filters';

export default {
  keys: [
    {
      title: 'SMS_SENT',
      filter: (obj) => {
        const { checked } = obj;
        const { smsEnabled, smsType, eventSmsEnabled } = obj.customer;
        let enabled = smsType === 'normal' ? smsEnabled : eventSmsEnabled;
        return `<input type="checkbox" ${checked ? 'checked' : ''} ${
          enabled === false ? 'disabled' : ''
        }
            
            data-type="check"
            style="width:20px;height:20px;cursor:pointer; ${
              enabled === false ? 'cursor:not-allowed;' : ''
            } "
            />
          `;
      },
    },
    {
      title: 'LABEL_CONDITION_CUSTOMER_NAME',
      column: 'name',
      filter: (obj) => {
        const { name } = obj.customer;
        if (name) {
          return `${name}`;
        }
        return `-`;
      },
    },
    {
      title: 'LABEL_CONDITION_CUSTOMER_PHONENUMBER',
      column: 'phoneNumber',
      filter: (o) => {
        return formatCallerNumber(o.customer.phoneNumber);
      },
    },
    {
      title: '일반 문자수신',
      column: 'smsEnabled',
      filter: (obj) => {
        const { smsEnabled } = obj.customer;
        if (false === smsEnabled) {
          return `${translate('DISAGREE')}`;
        }
        if (true === smsEnabled) {
          return `${translate('AGREE')}`;
        }
        return `-`;
      },
    },
    {
      title: 'EVENT_SMS_ENABLED',
      column: 'eventSmsEnabled',
      filter: (obj) => {
        const { eventSmsEnabled } = obj.customer;
        if (false === eventSmsEnabled) {
          return `${translate('DISAGREE')}`;
        }
        if (true === eventSmsEnabled) {
          return `${translate('AGREE')}`;
        }
        return `-`;
      },
    },
  ],
};
